import { api } from "./client";

export interface Vessel {
  id: string;
  name: string;
  imo_number: string | null;
  flag: string | null;
  vessel_type: string | null;
  contact_email: string | null;
  active: number;
  created_at: string;
  company_name?: string | null;
}

export const vesselsApi = {
  list: () => api.get<Vessel[]>("/api/vessels"),

  get: (id: string) => api.get<Vessel>(`/api/vessels/${id}`),

  create: (body: { name: string; imoNumber?: string; flag?: string; vesselType?: string; contactEmail: string; passwordHash: string }) =>
    api.post<{ id: string }>("/api/vessels", body),

  update: (
    id: string,
    body: Partial<{ name: string; imoNumber: string; flag: string; vesselType: string; contactEmail: string; active: boolean; passwordHash: string }>
  ) => api.patch<{ ok: boolean }>(`/api/vessels/${id}`, body),

  remove: (id: string) => api.delete<{ ok: boolean }>(`/api/vessels/${id}`),
};
